import React from 'react';
import { Formik, Form, Field } from 'formik';
import styled from 'styled-components';
import * as Yup from 'yup';
import Button from '../shared/Button';
import { db } from '../../api/fire';

const StyledForm = styled.div`
  max-width: 700px;
  width: 100%;
  flex: 1 1 auto;

  form {
    /* margin: 0 50px; */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }
  input {
    font-size: 18px;
    width: 90%;
    margin-top: 20px;
    display: block;
    padding: 15px;
    border-radius: 20px;
    background: none;
    border: 2px solid white;
    outline: none;
    color: white;
    @media (max-width: 425px) {
      margin-top: 30px;
    }
    &::placeholder {
      color: white;
      font-family: 'gothambook';
    }
  }
  textarea {
    width: 90%;
    font-size: 18px;
    margin-top: 20px;
    height: 200px;
    display: block;
    padding: 15px;
    border-radius: 20px;
    background: none;
    border: 2px solid white;
    outline: none;
    color: white;
    @media (max-width: 425px) {
      margin-top: 30px;
    }
    &::placeholder {
      color: white;
      font-family: 'gothambook';
      font-weight: 300;
    }
  }
  button {
    margin-top: 20px;
    @media (max-width: 425px) {
      margin-top: 40px;
    }
  }
  span {
    align-self: flex-start;
    margin-top: 10px;
    margin-left: 40px;
  }
`;

const ContactSchema = Yup.object().shape({
  fullName: Yup.string()
    .min(3, 'Full Name must have atleast 3 Character!')
    .max(30, 'Full Name must be under 200 Character!')
    .required('Required'),
  contactNo: Yup.number('Contact Number must be a number')
    .min(1000000000, 'Enter a valid mobile number!')
    .max(9999999999, 'Enter a valid mobile number!')
    .required('Required'),
  message: Yup.string().min(10, 'Too Short!').required('Required'),
});

const ContactForm = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [hasError, setHasError] = React.useState(false);

  const handleSubmit = (values) => {
    const { fullName, contactNo, message } = values;
    setIsLoading(true);
    db.collection('messages')
      .add({ fullName, contactNo, message })
      .then(() => {
        setIsLoading(false);
        setHasError(false);
      })
      .catch(() => {
        setIsLoading(false);
        setHasError(true);
      });
  };

  return (
    <StyledForm>
      <Formik
        initialValues={{
          fullName: '',
          contactNo: '',
          message: '',
        }}
        validationSchema={ContactSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched, isValid }) => (
          <Form>
            <Field id="fullName" name="fullName" placeholder="Full Name" />
            {errors.fullName && touched.fullName ? (
              <span>{errors.fullName}</span>
            ) : null}
            <Field
              id="contactNo"
              name="contactNo"
              placeholder="Contact Number"
            />
            {errors.contactNo && touched.contactNo ? (
              <span>{errors.contactNo}</span>
            ) : null}
            <Field
              component="textarea"
              id="message"
              name="message"
              placeholder="Your Message"
            />
            {errors.message && touched.message ? (
              <span>{errors.message}</span>
            ) : null}
            {isLoading ? (
              <Button>{hasError ? 'Error' : 'Loading'}</Button>
            ) : (
              <Button type="submit" disabled={!isValid}>
                Send message
              </Button>
            )}
          </Form>
        )}
      </Formik>
    </StyledForm>
  );
};

export default ContactForm;
